import * as tslib_1 from "tslib";
import * as React from 'react';
import { ViewerScriptHandler } from '../../viewerScriptHandler';
import { WixAdapter, viewModes } from '../../wixAdapter/wixAdapter';
import * as _ from 'lodash';
import * as FontFaceObserver from 'fontfaceobserver';
function stripQuotes(str) {
    return str.replace(/^["']|["']$/g, '');
}
function getFontFamilies(font) {
    return (font.cssFontFamily || font.family || '')
        .split(',')
        .filter(Boolean)
        .map(stripQuotes);
}
function SDKMock(Wix) {
    if (Wix.Utils.getViewMode() === 'standalone') {
        var mockWix = {};
        _.set(mockWix, 'getApplicationFields', function (appDef, cb) { return cb(); });
        _.set(mockWix, 'Utils.getViewMode', function () { return 'standalone'; });
        _.set(mockWix, 'Utils.getCompId', function () { return 'compId1'; });
        _.set(mockWix, 'Utils.getDeviceType', function () { return 'desktop'; });
        _.set(mockWix, 'Utils.getInstanceValue', function () { return ''; });
        _.set(mockWix, 'Utils.getSiteRevision', function () { return '1'; });
        _.set(mockWix, 'Utils.getUid', function () { return '00000000-0000-0000-0000-000000000000'; });
        _.set(mockWix, 'currentMember', function (cb) { return cb({ id: '00000000-0000-0000-0000-000000000000' }); });
        _.set(mockWix, 'Styles.getSiteColors', function (cb) { return cb({}); });
        _.set(mockWix, 'Styles.getSiteTextPresets', function (cb) { return cb({}); });
        _.set(mockWix, 'Styles.getStyleParams', function (cb) { return cb({}); });
        _.set(mockWix, 'getExternalId', function (cb) { return cb(); });
        _.set(mockWix, 'Data.Public.get', function (item, data, cb) { return cb(); });
        _.set(mockWix, 'Data.SCOPE.COMPONENT', 'COMPONENT');
        _.set(mockWix, 'getBoundingRectAndOffsets', function (cb) { return cb({ rect: {} }); });
        _.set(mockWix, 'getSiteInfo', function (cb) { return cb({}); });
        _.set(mockWix, 'Styles.getStyleId', function (cb) { return cb('style-jp8ide5x'); });
        _.set(mockWix, 'getCurrentPageId', function (cb) { return cb('c1dmp'); });
        _.set(mockWix, 'isAppSectionInstalled', function (sectionId, options, cb) { return cb(true); });
        Wix = _.defaults(Wix, mockWix);
    }
    return Wix;
}
export function ViewerScriptWrapper(WrappedComponent, appParams) {
    var widgetConfig = appParams.widgetConfig;
    var viewerScript = appParams.viewerScript;
    var wixAdapter = new WixAdapter(SDKMock(appParams.Wix));
    return /** @class */ (function (_super) {
        tslib_1.__extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.publicData = {};
            _this.loadedFonts = null;
            _this.state = {
                isControllerReady: false,
                isFontsLoaded: false,
                isFirstLoad: true,
                wixCodeProps: null,
                id: null,
                style: null,
                viewMode: null,
                formFactor: null,
                onSiteReady: null,
                raven: null,
                registerToScroll: null,
                dimensions: {
                    width: null,
                    height: null,
                    top: null,
                    left: null,
                },
                loadFonts: null,
                resizeComponent: null,
                externalId: null,
                styleId: null,
                pageId: null,
            };
            _this.initControllers = _this.initControllers.bind(_this);
            _this.updatePublicData = _this.updatePublicData.bind(_this);
            _this.updateDimensions = _this.updateDimensions.bind(_this);
            _this.markFontsLoaded = _this.markFontsLoaded.bind(_this);
            _this.handleExternalListeners();
            return _this;
        }
        class_1.prototype.handleExternalListeners = function () {
            var supportedExternalListeners = {
                publicData: this.updatePublicData,
            };
            if (_.isFunction(appParams.addExternalListeners)) {
                var requiredListeners_1 = appParams.addExternalListeners();
                Object.keys(supportedExternalListeners).forEach(function (key) {
                    if (_.isFunction(requiredListeners_1[key])) {
                        requiredListeners_1[key](supportedExternalListeners[key]);
                    }
                });
            }
        };
        class_1.prototype.componentDidMount = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _a, dimensions, widgetStyle, siteInfo, styleId, pageId, _b, style, publicData, externalId;
                return tslib_1.__generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, Promise.all([
                                wixAdapter.getDimensions(),
                                wixAdapter.getWidgetStyle(),
                                wixAdapter.getSiteInfo(),
                                wixAdapter.getStyleId(),
                                wixAdapter.getPageId(),
                            ])];
                        case 1:
                            _a = _c.sent(), dimensions = _a[0], widgetStyle = _a[1], siteInfo = _a[2], styleId = _a[3], pageId = _a[4];
                            this.viewerScriptHandler = new ViewerScriptHandler(viewerScript, wixAdapter, this.updateWixCodeProps.bind(this), siteInfo, appParams.overrides);
                            return [4 /*yield*/, this.viewerScriptHandler.initAppForPage()];
                        case 2:
                            _c.sent();
                            return [4 /*yield*/, this.getControllerConfigData()];
                        case 3:
                            _b = _c.sent(), style = _b.style, publicData = _b.publicData, externalId = _b.externalId;
                            this.initControllers({ style: style, publicData: publicData, externalId: externalId });
                            this.registerNavigationHooks();
                            if (wixAdapter.isEditorMode() || wixAdapter.isPreviewMode()) {
                                this.registerEditorHooks();
                            }
                            this.updateComponentProps({
                                id: wixAdapter.getCompId(),
                                style: widgetStyle,
                                resizeComponent: function (options) { return wixAdapter.resizeComponent(options); },
                                formFactor: wixAdapter.getDeviceType(),
                                viewMode: wixAdapter.getViewMode(),
                                dimensions: dimensions,
                                styleId: styleId,
                                pageId: pageId,
                            });
                            this.publicData = publicData;
                            this.warmupFonts();
                            return [2 /*return*/];
                    }
                });
            });
        };
        class_1.prototype.warmupFonts = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var widgetStyle, fontsToLoad, loadedFonts, unloadedFonts, shouldLoadFonts;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, wixAdapter.getWidgetStyle()];
                        case 1:
                            widgetStyle = _a.sent();
                            fontsToLoad = _(widgetStyle.styleParams.fonts)
                                .pickBy(function (font) { return font.fontStyleParam; })
                                .map(function (font) { return getFontFamilies(font); })
                                .uniq()
                                .flatten()
                                .value();
                            loadedFonts = this.loadedFonts || [];
                            unloadedFonts = _.differenceWith(fontsToLoad, loadedFonts, _.isEqual);
                            shouldLoadFonts = this.loadedFonts === null || unloadedFonts.length > 0;
                            this.loadedFonts = loadedFonts.concat(unloadedFonts);
                            if (!shouldLoadFonts) {
                                return [2 /*return*/];
                            }
                            this.loadFonts(fontsToLoad)
                                .then(this.markFontsLoaded)
                                .catch(function (e) {
                                console.error('failed to load fonts', e);
                                _this.markFontsLoaded();
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        class_1.prototype.updateComponentProps = function (newProps) {
            this.setState(_.cloneDeep(newProps));
        };
        class_1.prototype.markFontsLoaded = function () {
            this.setState({ isFontsLoaded: true });
        };
        class_1.prototype.loadFonts = function (fontsList) {
            var observers = _.map(fontsList, function (font) { return new FontFaceObserver(font).load(); });
            return Promise.all(observers);
        };
        class_1.prototype.isCompOnMasterPage = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var compInfo;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, wixAdapter.getComponentInfo()];
                        case 1:
                            compInfo = _a.sent();
                            return [2 /*return*/, compInfo.showOnAllPages];
                    }
                });
            });
        };
        class_1.prototype.registerNavigationHooks = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.isCompOnMasterPage()];
                        case 1:
                            if (_a.sent()) {
                                wixAdapter.onEveryPageNavigation(function () { return _this.handleNavigation(); });
                            }
                            else {
                                wixAdapter.onNavigationToComponentPage(function () { return _this.handleNavigation(); });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        class_1.prototype.handleNavigation = function () {
            var _this = this;
            this.onBeforeUnLoad();
            return this.viewerScriptHandler
                .initAppForPage()
                .then(function () { return _this.getControllerConfigData(); })
                .then(this.initControllers);
        };
        class_1.prototype.onBeforeUnLoad = function () {
            if (this.viewerScriptHandler) {
                this.viewerScriptHandler.onBeforeUnLoad();
            }
        };
        class_1.prototype.registerEditorHooks = function () {
            var _this = this;
            wixAdapter.onPublicDataChanged(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var publicData;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getPublicData()];
                        case 1:
                            publicData = _a.sent();
                            this.updatePublicData(publicData);
                            return [2 /*return*/];
                    }
                });
            }); });
            wixAdapter.onStyleParamChanged(function () { return _this.updateStyle(); });
            wixAdapter.onViewModeChanged(function (eventData) {
                if (eventData.editMode === viewModes.PREVIEW || eventData.editMode === viewModes.EDITOR) {
                    _this.onBeforeUnLoad();
                    _this.viewerScriptHandler
                        .initAppForPage()
                        .then(function () { return _this.getControllerConfigData(); })
                        .then(_this.initControllers);
                }
            });
            window.addEventListener('resize', _.debounce(this.updateDimensions, 100));
        };
        class_1.prototype.getControllerConfigData = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _a, styleParams, publicData, externalId;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, Promise.all([
                                wixAdapter.getStyleParams(),
                                this.getPublicData(),
                                wixAdapter.getExternalId(),
                            ])];
                        case 1:
                            _a = _b.sent(), styleParams = _a[0], publicData = _a[1], externalId = _a[2];
                            return [2 /*return*/, { style: { styleParams: styleParams }, publicData: publicData, externalId: externalId }];
                    }
                });
            });
        };
        class_1.prototype.updateDimensions = function () {
            var _this = this;
            wixAdapter.getDimensions().then(function (dimensions) { return _this.updateComponentProps({ dimensions: dimensions }); });
        };
        class_1.prototype.updateWixCodeProps = function (newProps) {
            this.setState({
                wixCodeProps: tslib_1.__assign({}, this.state.wixCodeProps, newProps),
            });
        };
        class_1.prototype.initControllers = function (controllerConfig) {
            var _this = this;
            this.viewerScriptHandler
                .initControllers(widgetConfig, controllerConfig, wixAdapter.getCompId())
                .then(function () { return _this.setState({ isControllerReady: true }); });
        };
        class_1.prototype.getPublicData = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    return [2 /*return*/, widgetConfig.getAllPublicData
                            ? wixAdapter.getAllPublicData()
                            : wixAdapter.getPublicDataByKeys(widgetConfig.dataKeys)];
                });
            });
        };
        class_1.prototype.updatePublicData = function (publicData) {
            this.publicData = tslib_1.__assign({}, this.publicData, publicData);
            this.updateController({
                publicData: this.publicData,
                style: this.state.style,
                externalId: this.state.externalId,
            });
        };
        class_1.prototype.updateStyle = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var style;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, Promise.all([wixAdapter.getWidgetStyle(), this.warmupFonts()])];
                        case 1:
                            style = (_a.sent())[0];
                            this.setState({ style: style });
                            this.updateController({
                                publicData: this.publicData,
                                style: style,
                                externalId: this.state.externalId,
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        class_1.prototype.updateController = function (controllerConfig) {
            if (this.viewerScriptHandler) {
                this.viewerScriptHandler.updateController(controllerConfig);
            }
        };
        class_1.prototype.reportLoaded = function () {
            if (this.state.isFirstLoad) {
                wixAdapter.loaded();
                this.setState({ isFirstLoad: false });
            }
        };
        class_1.prototype.render = function () {
            var hostProps = {
                style: this.state.style,
                id: this.state.id,
                viewMode: this.state.viewMode,
                formFactor: this.state.formFactor,
                dimensions: this.state.dimensions,
                appLoadBI: {
                    loaded: this.reportLoaded.bind(this),
                    startLoading: function () { return null; },
                },
                onSiteReady: _.noop,
                loadFonts: this.state.loadFonts,
                pageId: this.state.pageId,
                styleId: this.state.styleId,
                raven: null,
                registerToScroll: _.noop,
                registerToComponentDidLayout: function (cb) { return cb(); },
                resizeComponent: this.state.resizeComponent,
                updateLayout: _.noop,
            };
            var props = tslib_1.__assign({ host: hostProps }, hostProps, this.state.wixCodeProps);
            return this.state.isControllerReady && this.state.isFontsLoaded && React.createElement(WrappedComponent, tslib_1.__assign({}, _.cloneDeep(props)));
        };
        return class_1;
    }(React.Component));
}
//# sourceMappingURL=viewerScriptWrapper.js.map